
export const ENV = {
    BASE_URL: '',
    API_MODE: 'api',//json
    API_URL: 'https://api.prod.itakusaki-manager.deloitte.jp/api/',
	APP_API_URL: 'https://api.prod.itakusaki-manager.deloitte.jp/api/',
	APP_URL_BANNER: 'https://api.prod.itakusaki-manager.deloitte.jp/storage/'
}

export default ENV;
